export default __webpack_public_path__ + "static/media/import-two.bbf37c28.png";